import { useTranslation } from "react-i18next";

export function Wordmark({ className = "" }: { className?: string }) {
  const { t } = useTranslation("common");
  return (
    <span className={`font-mono text-data font-medium tracking-wide text-ink ${className}`}>
      {t("appName")}
    </span>
  );
}
